import {css} from 'styled-components'

export const userSelect = {
    none: css`
        user-select: none;
        -webkit-user-select: none;
    `
}
